import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import actionFe from 'utils/mw/actionFe.util';
import tracked from 'utils/redux/tracked.util';

export const feSidebarAppointmentChange = actionFe('feSidebarAppointmentChange');
export const feSidebarAppointmentClear = actionFe('feSidebarAppointmentClear');
export const feSidebarAppointmentClearAndChange = actionFe('feSidebarAppointmentClearAndChange');

export const feSidebarClose = actionFe('feSidebarClose');
export const feSidebarDim = actionFe('feSidebarDim');
export const feSidebarOpen = actionFe('feSidebarOpen');

export const feSidebarDetourDepart = actionFe('feSidebarDetourDepart');
export const feSidebarDetourReturn = actionFe('feSidebarDetourReturn');

export const feSidebarNavigateToAppointment = actionFe('feSidebarNavigateToAppointment');
export const feSidebarReturnFromAppointment = actionFe('feSidebarReturnFromAppointment');

export const feProcedureModalMount = actionFe('feProcedureModalMount');

export const feSalonUpdate = actionFe('feSalonUpdate');

export const feRequestDepositValue = actionFe('feRequestDepositValue');
export const feTakeDepositInput = actionFe('feTakeDepositInput');
export const feSetDepositSource = actionFe('feSetDepositSource');

export const feRebookDirtyTime = actionFe('feRebookDirtyTime');

export const feStripeFoldToggle = actionFe('feStripeFoldToggle');
export const feBusinessStripeFoldToggle = actionFe('feBusinessStripeFoldToggle');
export const feTipsFoldToggle = actionFe('feTipsFoldToggle');
export const fePolicyFoldToggle = actionFe('fePolicyFoldToggle');
export const fePolicyFoldOpen = actionFe('fePolicyFoldOpen');
export const fePolicyFocusNote = actionFe('fePolicyFocusNote');
export const feVoucherPanelToggle = actionFe('feVoucherPanelToggle');

export const feSetStylistId = actionFe('feSetStylistId');

export const feCleanCheckoutData = actionFe('feCleanCheckoutData', alwaysSame, tracked);
export const feSetCheckoutInitDataFromClientProfile = actionFe('feSetCheckoutInitDataFromClientProfile');
